import { MessageStatus } from "../enum/message_status";
import { toMessageFrom } from "../enum/message_from";
import MessageModel from "../model/message_model";
import { MessageFrom } from "../enum/message_from";
import { DateUtils } from "../../../core/utils/date_utils";
import ImageModel from "../model/image_model";

export const toMessageModel = async (object) => {
  const createdAt = new Date(object.createdAt);
  const dateString = DateUtils.formatDate(createdAt);
  const messageFrom = toMessageFrom(object.sendBy);
  const images = [];
  for (let i = 0; i < object.images.length; i++) {
    const imageData = object.images[i];
    const imageId = imageData.imageId;
    const imageUrl = imageData.imageUrl;
    const imageName = imageData.imageName;
    const createdDate = new Date(imageData.createdDate);
    const isBlur = imageData.isBlur;
    const imageModel = new ImageModel({
      id: imageId,
      imageUrl: imageUrl,
      imageName: imageName,
      createdDate: createdDate,
      isBlur: isBlur,
    });
    images.push(imageModel);
  }
  return new MessageModel({
    id: object._id,
    message: object.content,
    from: messageFrom,
    status: MessageStatus.seen,
    dateString: dateString,
    images: images,
  });
};

export const chatCompletionResultToMessageModel = async (object) => {
  const createdAt = new Date();
  const dateString = DateUtils.formatDate(createdAt);
  const images = [];
  for (let i = 0; i < object.images.length; i++) {
    const imageData = object.images[i];
    const imageId = imageData.imageId;
    const imageUrl = imageData.imageUrl;
    const imageName = imageData.imageName;
    const createdDate = new Date(imageData.createdDate);
    const isBlur = imageData.isBlur;
    const imageModel = new ImageModel({
      id: imageId,
      imageUrl: imageUrl,
      imageName: imageName,
      createdDate: createdDate,
      isBlur: isBlur,
    });
    images.push(imageModel);
  }
  return new MessageModel({
    message: object.response,
    from: MessageFrom.avatar,
    status: MessageStatus.delivered,
    dateString: dateString,
    images: images,
  });
};
